//Libraries
import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { NavLink } from "react-router-dom"; //make sure to import all the components.
import Toggle from "react-toggle";

//My utils
import Project_search_table_row from "../../components/project_search_table_row/project_search_table_row";

//redux stuff
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";

//styles
import "./SearchProjects.scss";
import styles from "../../styles/modules/SearchProjects.module.scss";

// dialog dependencies
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import ReactLoader from "react-loader-spinner";
import Translated from "../../components/Translated/Translated";
import translator from "../../utils/translator";

export class SearchProjects extends Component {
	limit = 10; // Number of records per page
	pagination_count = 10; // Number of pagination buttons to show
	searchURL = this.props.APIUrl + "/projects/search";
	sort_fields = {
		id: "id",
		title: "title",
		account_id: "account_id",
		account_name: "account_name",
		ship_to: "ship_to",
		warehouse: "warehouse",
		consultant: "created_by",
		date: "date_added",
		status: "project_lost",
		order: "trend_order_number", // I don't know what this is. I left it just in case. Not worth my time trying to understand it since i didn't make thsi code. We might even be using. I did a quick check and it seems like we aren't using it.
		note: "notes",
		order_number: "data1" // This is used to sort the Order Number column in the search projects front end table
	};

	static propTypes = {
		prop: PropTypes
	};

	state = {
		projects: [],
		total: 0,
		page: 1,
		start_page: 1,
		search: "",
		sort: this.sort_fields.date,
		sort_asc: false,
		active: 1,
		loading: 0,
		exportResponseDialog: null,
		warehouseFilter: false,
		consultantFilter: false,
		accountFilter: false,
		accountNameFilter: false,
		useFilters: false,
	};

	callSearch = async () => {
		let state = this.state;
		let filters = {
			warehouse: state.warehouseFilter,
			consultant: state.consultantFilter,
			account: state.accountFilter,
			accountName: state.accountNameFilter,
		}
		let searchData = {
			user: localStorage.getItem("trendId"),
			searchCriteria: state.search,
			page: state.page,
			limit: this.limit,
			sort: state.sort,
			order: state.sort_asc ? "ASC" : "DESC",
			active: state.active,
			useFilters: state.useFilters,
			filters,
		};
		try {
			this.setState({ loading: 1 });
			let response = await axios.post(this.searchURL, searchData);
			this.setState({
				projects: response.data.projects,
				total: response.data.total,
				loading: 0
			});
		} catch (e) {
			console.log(e);
		}
	};

	callNewSearch = async () => {
		// Resets the pagination
		this.setState({ page: 1, start_page: 1 }, this.callSearch);
	};

	toggleSort = field => {
		let newState;
		if (this.state.sort === this.sort_fields[field]) {
			newState = state => ({ sort_asc: state.sort_asc ? false : true });
		} else {
			newState = { sort: this.sort_fields[field], sort_asc: field === "date" ? false : true };
		}
		this.setState(newState, this.callSearch);
	};

	async componentDidMount() {
		await this.props.clearRoomNames(); // so it doesn't pile up when you click to project set up. the rooms pile up
		this.callSearch();
	}

	checkIfTheyPressedEnter = event => {
		var code = event.keyCode || event.which;
		if (code === 13) {
			//13 is the enter keycode
			this.callNewSearch();
		}
	};

	checkIfPageDisabled = (page, total) => {
		return (page - 1) * this.limit + 1 > total;
	};

	renderSortButton = (field, title) => {
		return field === "amount" ? (
			<button disabled className={styles.sort_button}>
				{title}
			</button>
		) : (field === "status" && this.state.active) ||
		  (field === "order_number" && this.state.active) ? null : (
			<button className={styles.sort_button} onClick={() => this.toggleSort(field)}>
				{title}
				{this.state.sort === this.sort_fields[field] ? (
					<div className={styles.sort_icon}>
						{this.state.sort_asc ? (
							<i class="fas fa-angle-up"></i>
						) : (
							<i class="fas fa-angle-down"></i>
						)}
					</div>
				) : (
					""
				)}
			</button>
		);
	};

	closeDisplayUpdatedProjectPriceDialog = async () => {
		await this.setState({ exportResponseDialog: null });
	};

	exportHandlerFunction = async () => {
		// Export and the email to the user
		let exportProjectAPIUrl = this.props.APIUrl + "/projects/export";
		let data = {
			archived: this.state.active ? 0 : 1,
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
		};

		await this.setState({ loading: 1 });

		let exportResponseDialog = (
			<Dialog open={true} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					<Translated section="Misc" label="report_export_dialog_title" />{" "}
				</DialogTitle>
				<DialogContent style={{ paddingRight: "10em" }}>
					{this.state.loading === 1 ? (
						<ReactLoader
							style={{ marginLeft: "8em" }}
							type="Oval"
							color="#00BFFF"
							height={50}
							width={50}
						/>
					) : (
						<React.Fragment>
							<DialogContentText>
								<p><Translated section="Reports" label="email_send_success" /></p>
							</DialogContentText>
							<Button
								style={{ marginLeft: "10em" }}
								id="set-price-close-button"
								onClick={this.closeDisplayUpdatedProjectPriceDialog}
								color="primary"
							>
								<Translated section="Misc" label="ok_btn" />
							</Button>
						</React.Fragment>
					)}
				</DialogContent>
			</Dialog>
		);

		await this.setState({ exportResponseDialog });

		let exportProjectAPIResponse = await axios.post(exportProjectAPIUrl, data);

		// Check if everything went well. If not load forever.
		if (exportProjectAPIResponse.data.api_response.success) {
			this.setState({ loading: 0 });
			exportResponseDialog = (
				<Dialog open={true} aria-labelledby="form-dialog-title">
					<DialogTitle id="form-dialog-title set-price-dialog-header">
						<Translated section="Misc" label="report_export_dialog_title" />{" "}
					</DialogTitle>
					<DialogContent style={{ paddingRight: "10em" }}>
						{this.state.loading === 1 ? (
							<DialogContentText>
								<ReactLoader
									type="Oval"
									color="#00BFFF"
									height={100}
									width={100}
								/>{" "}
							</DialogContentText>
						) : (
							<React.Fragment>
								<DialogContentText>
									<p><Translated section="Reports" label="email_send_success" /></p>
								</DialogContentText>
								<Button
									style={{ marginLeft: "10em" }}
									id="set-price-close-button"
									onClick={this.closeDisplayUpdatedProjectPriceDialog}
									color="primary"
								>
									<Translated section="Misc" label="ok_btn" />
								</Button>
							</React.Fragment>
						)}
					</DialogContent>
				</Dialog>
			);
			this.setState({ exportResponseDialog });
		}
	};

	searchFilters = async (event) => {
		// await setStates into their own function so callSearch will have the proper values
		await this.setFilters(event.target);

		if(!!this.state.search) {
			await this.callSearch();
		}
	};

	setFilters = async (eventTarget) => {
		this.setState({
			warehouseFilter: false,
			consultantFilter: false,
			accountFilter: false,
			accountNameFilter: false,
			useFilters: false
		});

		if(eventTarget.checked) {
			this.setState({
				[eventTarget.name+'Filter']: true,
				useFilters: true
			});
		}
	};

	render() {
		let state = this.state;
		let top_record = (state.page - 1) * this.limit + 1;
		let prev_disabled = (state.start_page - this.pagination_count) * this.limit < 1;
		let next_disabled = (state.start_page + this.pagination_count) * this.limit > state.total;

		// -- The key is what has to match the this.sort_fields object at the top of this file. The value for the below array is what will be displayed in the table. The this.sort_fields contains the value that has to match the table column name because we will be using that to sort the results. If you read all the code that is what you will understand from it. --
		let sort_buttons = [
			["id", translator("Misc", "project_id_label")],
			["title", translator("Misc", "project_title_label")],
			["account_id", translator("Misc", "account_label")],
			["account_name", translator("Misc", "account_name_label")],
			["ship_to", translator("Misc", "ship_to_label")],
			["warehouse", translator("Misc", "warehouse_label")],
			["consultant", translator("Misc", "team_member_label")],
			["date", translator("Misc", "date_created_label")],
			["amount", translator("Misc", "amount_placeholder")],
			["note", translator("Misc", "notes_label")],
			["status", translator("Misc", "project_status_label")],
			["order_number", translator("Misc", "order_number_label")]
		];

		let exportResponseDialog = state.exportResponseDialog;
		return (
			<div className={"search-projects-page"}>
				<div className={styles.top_wrapper}>
					<h1>
						{" "}
						{this.props.selected_language_translations === null
							? null
							: this.props.selected_language_translations["Search Projects"]
									.sub_heading[this.props.selected_language]}
					</h1>
					<div className={styles.search_wrapper}>
						<input
							type="text"
							placeholder={translator("Product Shopping", "search_btn")}
							aria-label="Search"
							onChange={async event =>
								await this.setState({ search: event.target.value })
							}
							onKeyPress={this.checkIfTheyPressedEnter}
						/>
						<button onClick={this.callNewSearch} type="button">
							<i class="fa fa-search" />
						</button>
					</div>
					<div className={styles.top_right}>
						<NavLink className={styles.top_button} to="/new-project" exact>
							{this.props.selected_language_translations === null
								? null
								: this.props.selected_language_translations["Home"]
										.new_project_link[this.props.selected_language]}
						</NavLink>
						<button onClick={this.exportHandlerFunction} className={styles.top_button}>
							{this.props.selected_language_translations === null
								? null
								: this.props.selected_language_translations["Misc"].export_label[
										this.props.selected_language
								  ]}
						</button>
						{exportResponseDialog}
						<Toggle
							id="active-project-toggle"
							className={styles.active_toggle}
							icons={{
								checked:
									this.props.selected_language_translations === null
										? null
										: this.props.selected_language_translations["Misc"]
												.active_label[this.props.selected_language],
								unchecked:
									this.props.selected_language_translations === null
										? null
										: this.props.selected_language_translations["Misc"]
												.archived_label[this.props.selected_language]
							}}
							checked={state.active}
							onChange={() =>
								this.setState(
									state => ({
										active: state.active ? 0 : 1,
										sort: this.sort_fields.date,
										sort_asc: false
									}),
									this.callNewSearch
								)
							}
						/>
					</div>
				</div>
				
				<div className={styles.filter_wrapper}>
					<div className={styles.filter_title}><Translated section="Misc" label="filter_by_label" /></div>
					{localStorage.getItem("perm_extra_project_filters") && (
						<>
							<div class={styles.filter_check}>
								<input
									onChange={this.searchFilters}
									checked={state.warehouseFilter}
									type="checkbox"
									className={styles.filter_check_input}
									id="display_warehouse"
									name="warehouse"
								/>
								<label className={styles.filter_check_label} for="display_warehouse">
									<Translated section="Misc" label="warehouse_label" />
								</label>
							</div>

							<div class={styles.filter_check}>
								<input
									onChange={this.searchFilters}
									checked={state.consultantFilter}
									type="checkbox"
									className={styles.filter_check_input}
									id="display_consultant"
									name="consultant"
								/>
								<label className={styles.filter_check_label} for="display_consultant">
									<Translated section="Misc" label="consultant_label" />
								</label>
							</div>
						</>
					)}
					<div class={styles.filter_check}>
						<input
							onChange={this.searchFilters}
							checked={state.accountFilter}
							type="checkbox"
							className={styles.filter_check_input}
							id="display_account"
							name="account"
						/>
						<label className={styles.filter_check_label} for="display_account">
							<Translated section="Misc" label="account_label" />
						</label>
					</div>

					<div class={styles.filter_check}>
						<input
							onChange={this.searchFilters}
							checked={state.accountNameFilter}
							type="checkbox"
							className={styles.filter_check_input}
							id="display_account_name"
							name="accountName"
						/>
						<label className={styles.filter_check_label} for="display_account_name">
							<Translated section="Project Search" label="account_name_label" />
						</label>
					</div>
				</div>

				{this.props.selected_language_translations === null 
					? null
					: (
						this.props.selected_language_translations["Home"]
						.banner_notice[this.props.selected_language] !== '' && (
							<div className={styles.alert_banner}>
								<div 
									dangerouslySetInnerHTML={{__html: this.props.selected_language_translations["Home"]
										.banner_notice[this.props.selected_language]}}
								></div>
							</div>
						)
					)
				}

				<div className={styles.results_wrapper}>
					<div className={styles.results}>
						{state.total
							? `${
									this.props.selected_language_translations === null
										? null
										: this.props.selected_language_translations[
												"Search Projects"
										  ].result_pc_label[this.props.selected_language]
							  } ${top_record} - ${
									this.checkIfPageDisabled(1 + state.page, state.total)
										? state.total
										: top_record + this.limit - 1
							  } ${
									this.props.selected_language_translations === null
										? null
										: this.props.selected_language_translations[
												"Search Projects"
										  ].of_pc_label[this.props.selected_language]
							  } ${state.total}`
							: translator("Misc", "no_results_found")}
					</div>
					{state.total > this.limit && (
						<div className={styles.pagination_wrapper}>
							<button
								disabled={prev_disabled}
								onClick={() =>
									this.setState({
										start_page: state.start_page - this.pagination_count
									})
								}
							>
								<i class="far fa-arrow-alt-circle-left" />
							</button>
							{Array(this.pagination_count)
								.fill(1)
								.map((dummy, i) =>
									!this.checkIfPageDisabled(i + state.start_page, state.total) ? (
										<button
											key={i} 
											className={
												i + state.start_page === state.page
													? styles.active_page
													: ""
											}
											disabled={this.checkIfPageDisabled(
												i + state.start_page,
												state.total
											)}
											onClick={() =>
												this.setState(
													{ page: i + state.start_page },
													this.callSearch
												)
											}
										>
											{i + state.start_page}
										</button>
									) : (
										""
									)
								)}
							<button
								disabled={next_disabled}
								onClick={() =>
									this.setState({
										start_page: state.start_page + this.pagination_count
									})
								}
							>
								<i class="far fa-arrow-alt-circle-right" />
							</button>
						</div>
					)}
				</div>

				<div class="search-table-wrapper">
					<table class="table search-results-table">
						<thead id="search-projects-table-header">
							<tr>
								<th scope="col">#</th>
								{sort_buttons.map((btn, index) => (
									<th key={index} scope="col">{this.renderSortButton(btn[0], btn[1])}</th>
								))}
							</tr>
						</thead>
						<tbody>
							{state.projects.map((project, index) => (
								<Project_search_table_row
									key={index}
									isItActive={state.active ? 1 : 0}
									reRenderSearchResults={this.callNewSearch}
									projectNumber={top_record + index}
									projectId={project.id}
									projectTitle={project.title}
									account={project.account_id}
									accountName={project.account_name}
									shipTo={project.ship_to}
									warehouse={project.warehouse}
									teamMember={project.created_by}
									dateCreated={
										project.date_added ? project.date_added.slice(0, 10) : null
									}
									amount={project.totalProjectCost}
									notes={project.notes}
									archival_reason={project.archival_reason}
									status={
										!!state.active
											? null
											: 1 -
											  (!!project.project_lost ? 1 : 0) +
											  (!!project.processed ? 1 : 0)
									}
									order={!!state.active ? null : project.order}
									reRenderProjectSearchResultsForCopyingAndArchiving={
										this.callSearch
									} // This is used to reRender in general so if you updated a note reRender it so if they open the notes dialog the updated text will appear
									trendArchive={project.trend_archive}
								/>
							))}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		searched_projects_results: state.searched_projects_results,
		APIUrl: state.APIUrl,
		selected_language_translations: state.language_translations,
		selected_language: state.selected_language
	};
};

const mapDispatchToProps = dispatch => {
	return {
		clearRoomNames: () =>
			dispatch({
				type: actionTypes.CLEAR_ROOM_NAMES
			})
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchProjects);
